const brXxs = '0.25rem';
const brXs = '0.5rem';
const brSm = '0.75rem';
const brMd = '1rem';
const brLg = '1.5rem';
const brXl = '4rem';

export const BORDER_RADIUS: Record<string, string> = {
    brXxs,
    brXs,
    brSm,
    brMd,
    brLg,
    brXl,
};
